import React, { useEffect, useMemo, useState } from 'react';
import { Bouton, LoaderMi } from '@design-system-etat/dsfr-react';

import {
    STATUT_A_COMPLETER,
    STATUT_TITRE_DETENTION,
    TYPE_DEMARCHE,
} from 'constants/titreDetention.constants';
import { STATUT_DECLARATION_A_COMPLETER } from 'constants/declaration.constants';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_GET_MES_DEMARCHES_EN_COURS,
    CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
    CONTEXT_MES_DEMARCHES_EN_COURS,
} from 'constants/apiUrls.constants';
import { getDateFRFromYYYYMMDDHHMMSS } from 'components/Commun/Form/Date/dateTranformation';
import { useDispatch, useSelector } from 'react-redux';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import ModaleModifierPiecesJointes from '../completerDemandePiecesJointes/ModaleModifierPiecesJointes';
import ModaleCertificatMedicalDeclaration from '../ajoutCertificatMedicalDeclaration/ModaleCertificatMedicalDeclaration';
import ModalePiecesJointesTitreDetention from '../completerDemandePiecesJointes/ModalePiecesJointesTitreDetention';

const MesDemarchesEnCours = () => {
    const dispatch = useDispatch();

    const { isLoading, data: mesDemarches } = useSelector(
        (state) => state.mesDemarchesEtAutorisations.mesDemarchesEnCours,
    );
    const { declarationArme, titreDetentions } = mesDemarches ?? {};
    const { isLoading: isLoadingEnvoyerPJ } = useSelector(
        (state) => state.mesDemarchesEtAutorisations.envoyerDemandePjs,
    );

    const [numeroDeclarationEnCours, setNumeroDeclarationEnCours] = useState();
    const [displayModaleModifierPiecesJointes, setDisplayModaleModifierPiecesJointes] =
        useState(false);
    const [displayModaleAjoutCertificatMedicalPj, setDisplayModaleAjoutCertificatMedicalPj] =
        useState(false);
    const [titreDetentionSelectionne, setTitreDetentionSelectionne] = useState({});

    const ouvrirModaleModifierPiecesJointes = () => {
        setDisplayModaleModifierPiecesJointes(true);
    };
    const ouvrirModaleAjoutCertificatMedicalPj = () => {
        setDisplayModaleAjoutCertificatMedicalPj(true);
    };
    const [afficherModalePiecesJointes, setAfficherModalePiecesJointes] = useState(false);

    const fermerModaleModifierPiecesJointes = () => {
        reinitialiseAPI(CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES);
        setDisplayModaleModifierPiecesJointes(false);
    };

    const fermerModaleAjoutCertificatMedicalPj = () => {
        setDisplayModaleAjoutCertificatMedicalPj(false);
    };

    const fermerModalePiecesJointes = () => {
        setAfficherModalePiecesJointes(false);
    };

    useEffect(() => {
        dispatch(
            getAPI(
                usagerClientReducer,
                API_GET_MES_DEMARCHES_EN_COURS,
                CONTEXT_MES_DEMARCHES_EN_COURS,
            ),
        );
    }, [titreDetentionSelectionne.statut]);

    const boutonAjoutPjs = (uuid) => {
        return (
            <>
                <Bouton
                    type="button"
                    niveau="secondaire"
                    icone="fr-fi-edit-line"
                    onClick={() => {
                        setNumeroDeclarationEnCours(uuid);
                        ouvrirModaleModifierPiecesJointes();
                    }}
                />
            </>
        );
    };

    const boutonAjoutCertificatMedicalPj = (uuid) => {
        return (
            <>
                <Bouton
                    type="button"
                    niveau="secondaire"
                    icone="fr-fi-edit-line"
                    onClick={() => {
                        setNumeroDeclarationEnCours(uuid);
                        ouvrirModaleAjoutCertificatMedicalPj();
                    }}
                />
            </>
        );
    };

    const affichageBoutonAction = (
        uuidDeclaration,
        statut,
        statutEnquete,
        demandeCertificatMedicalPsychiatrique,
    ) => {
        if (statut === STATUT_DECLARATION_A_COMPLETER && statutEnquete === null) {
            return boutonAjoutPjs(uuidDeclaration);
        }
        if (demandeCertificatMedicalPsychiatrique) {
            return boutonAjoutCertificatMedicalPj(uuidDeclaration);
        }
        return null;
    };

    const boutonActionsTitreDetention = (titre) => {
        if (
            titre.statut === STATUT_A_COMPLETER &&
            titre.piecesJointesManquantes &&
            titre.piecesJointesManquantes.length > 0
        ) {
            return (
                <Bouton
                    type="button"
                    niveau="secondaire"
                    icone="fr-fi-edit-line"
                    onClick={() => {
                        setTitreDetentionSelectionne(titre);
                        setAfficherModalePiecesJointes(true);
                    }}
                />
            );
        }

        return <></>;
    };

    const header = [
        'Type de démarche',
        'Numéro de dossier',
        'Statut',
        'Date de dépôt de la demande',
        'Actions',
    ];

    const donneesVides = [['Aucune démarche en cours', '', '', '', '']];

    const mesDemarchesEnCours = useMemo(() => {
        const demarchesEnCours = [];
        if (Array.isArray(declarationArme)) {
            declarationArme.forEach((declaration) => {
                const {
                    typeDeDemarche,
                    numeroDeDossier,
                    statut,
                    dateDeDepotDemande,
                    uuid,
                    statutEnquete,
                    demandeCertificatMedicalPsychiatrique,
                } = declaration;

                demarchesEnCours.push([
                    typeDeDemarche,
                    numeroDeDossier,
                    statut,
                    getDateFRFromYYYYMMDDHHMMSS(dateDeDepotDemande),
                    affichageBoutonAction(
                        uuid,
                        statut,
                        statutEnquete,
                        demandeCertificatMedicalPsychiatrique,
                    ),
                ]);
            });
        }

        if (Array.isArray(titreDetentions)) {
            titreDetentions.forEach((titreDetention) => {
                const { typeTitreDetention, numero, statut, dateDebut } = titreDetention;
                demarchesEnCours.push([
                    TYPE_DEMARCHE[typeTitreDetention],
                    numero,
                    STATUT_TITRE_DETENTION[statut],
                    getDateFRFromYYYYMMDDHHMMSS(dateDebut),
                    boutonActionsTitreDetention(titreDetention),
                ]);
            });
        }

        return demarchesEnCours;
    }, [declarationArme, titreDetentions]);

    return (
        <>
            {displayModaleModifierPiecesJointes && (
                <ModaleModifierPiecesJointes
                    fermerModale={fermerModaleModifierPiecesJointes}
                    uuidDeclaration={numeroDeclarationEnCours}
                />
            )}
            {displayModaleAjoutCertificatMedicalPj && (
                <ModaleCertificatMedicalDeclaration
                    fermerModale={fermerModaleAjoutCertificatMedicalPj}
                    uuidDeclaration={numeroDeclarationEnCours}
                />
            )}
            {afficherModalePiecesJointes && (
                <ModalePiecesJointesTitreDetention
                    titreDetention={titreDetentionSelectionne}
                    fermerModale={fermerModalePiecesJointes}
                    isLoading={isLoading}
                    isLoadingEnvoyerPJ={isLoadingEnvoyerPJ}
                />
            )}
            <div>
                {isLoading && <LoaderMi />}

                <SimpleTable
                    entete={header}
                    isLoading={isLoading}
                    donnees={
                        Array.isArray(mesDemarchesEnCours) && mesDemarchesEnCours.length
                            ? mesDemarchesEnCours
                            : donneesVides
                    }
                    boutonActionsPresent
                />
            </div>
        </>
    );
};

export default MesDemarchesEnCours;
